import { ChangeEvent, FC, useContext, useEffect } from 'react';
import { Box, Button, Pagination } from '@mui/material';
import { MAX_PACKAGES_PAGE_LIMIT } from '../../constants/numbers';
import { useTranslation } from 'react-i18next';
import PageCard from './PageCard';
import { CampaignContext } from '../../contexts/CampaignContext';
import { IEntity } from '../../interfaces/campaign';
import axios from 'axios';
import IResponse from '../../interfaces/response';
import { useParams } from 'react-router-dom';

type IPagesList = {
	filterCategory: any;
	searchTerm: string;
	onSave: () => void;
	onCancel: () => void;
};

const PagesList: FC<IPagesList> = ({ filterCategory, searchTerm, onSave, onCancel }) => {
	const { type } = useParams();
	const { t } = useTranslation();

	const { selectedPlatformId, sortPackages, entityPage, selectedPages, fetchedEntities, fetchedEntitiesPagination, typeActiveButton, categoryActiveButton, viewSelectedItemsMode, setFetchedEntites, setFetchedPackages, setFetchedEntitiesPagination, setSelectedPages, setEntityPage } = useContext(CampaignContext);

	const isProvincialActive = typeActiveButton === 1 && categoryActiveButton === 1;

	const handleSelect = (item: IEntity, checked: boolean) => {
		if (checked) {
			setSelectedPages([...selectedPages, item]);
		} else {
			setSelectedPages(selectedPages.filter(page => page.id !== item?.id));
		}
	};
	const handleChangePage = (_: ChangeEvent<unknown>, newPage: number) => {
		axios<IResponse<any>>({
			method: 'get',
			url: `/media_entities`,
			params: {
				page: newPage,
				campaign_type: type,
				title: searchTerm,
				media_id: selectedPlatformId?.toString(),
				limit: MAX_PACKAGES_PAGE_LIMIT.toString(),
				location_id: isProvincialActive ? filterCategory?.id : '',
				category_id: !isProvincialActive ? filterCategory?.id : '',
				order_by: sortPackages?.orderBy,
				order_by_direction: sortPackages?.orderByDirection,
			},
		}).then(res => {
			if (res.data.success) {
				setFetchedEntites(res.data.data);
				setFetchedPackages(res.data.data);
				setFetchedEntitiesPagination(res.data.pagination);
				// setFiltersAnchorEL?.(null);
			}
		});
		setEntityPage(newPage);
	};

	const handleCancel = () => {
		setSelectedPages([]);
		onCancel();
	};

	const totalItems = fetchedEntitiesPagination?.total;
	useEffect(() => {
		if (entityPage > Math.ceil(totalItems! / MAX_PACKAGES_PAGE_LIMIT)) {
			setEntityPage(1);
		}
	}, [searchTerm, entityPage, MAX_PACKAGES_PAGE_LIMIT, totalItems]);

	return (
		<Box className="flex flex-col justify-center">
			<Box className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-6">{(viewSelectedItemsMode ? selectedPages : fetchedEntities)?.map(pkg => <PageCard key={pkg.id} {...pkg} onSelect={handleSelect} />)}</Box>
			{!viewSelectedItemsMode && (
				<Box className="mt-8 flex w-full items-center justify-between">
					<Pagination count={Math.ceil(totalItems! / MAX_PACKAGES_PAGE_LIMIT)} page={entityPage} onChange={handleChangePage} variant="text" showFirstButton={false} showLastButton={false} className="flex justify-center" size="medium" shape="rounded" color="primary" />
					<Box className="flex items-center gap-x-5">
						<Button className="h-10 w-48" disabled={selectedPages.length === 0} onClick={onSave}>
							{t('register')}
						</Button>
						<Button className="h-10 w-48" variant="outlined" onClick={handleCancel}>
							{t('cancel')}
						</Button>
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default PagesList;
